import { accessors } from "./parser";

// Video settings and URLs
export const INTRO_VIDEO_URL = "https://vimeo.com/561276293/3d8ac90656";
export const SOUNDMACHINE_VIDEO_URL = "https://vimeo.com/563641014/c2b1ba91dc";
export const ABOUT_PROJECT_URL =
  "https://www.forensic-architecture.org/investigation/digital-violence-how-the-nso-group-enables-state-terror/";
export const AMNESTY_REPORT_URL =
  "https://www.amnesty.org/download/Documents/DOC1041822021ENGLISH.PDF";

export const SHOW_INTERVIEW_ARCHIVE = false;

// This is used as a placeholder to fill the gaps
// when creating the scales
export const BLANK_AXIS_NAME = "UNNAMED";

export const CHART_DIMENSIONS = {
  X: {
    MIN: 0,
    MAX: 35,
  },
  Y: {
    MIN: 0,
    MAX: 20,
    BANDWIDTH: 0.6,
  },
  Z: {
    MIN: 0,
    MAX: 25,
  },
};

// all these are coming from public/PATH
export const DATA_FILES = {
  MEDIA:
    process.env.REACT_APP_USE_DATA_FORMAT === "synthetic"
      ? "data/synthetic_media.json"
      : "data/media.json",
  EVENTS:
    process.env.REACT_APP_USE_DATA_FORMAT === "synthetic"
      ? "data/synthetic_events.json"
      : "data/events.json",
};

export const CARD_INVERT_PASTILE_COLOR_ON_EVENTS = ["N/A", "Corporate Event"];

export const FILTER_EVENT_TYPES_THAT_ENABLE_CARPET_VIEW = [
  "Corporate",
  "Exposures",
  "Related",
  "Murder",
  "Assault",
  "Intimidation",
  "Violence",
  "Zero Click:global",
  "One Click:global",
];

export const ATTRIBUTE_TYPE = {
  CONTEXTUAL: "contextual",
  GLOBAL: "global",
  TARGETED: "targeted",
};

// These are needed by the narrative
export const ALL_COUNTRIES = [
  "Mexico",
  "UAE",
  "Saudi Arabia",
  "Morocco",
  "India",
  "Rwanda",
  "Togo",
  "Spain",
];

export const ALL_BLUE_EVENTS = ["One Click", "Zero Click"];

export const ALL_YELLOW_EVENTS = ["Email/ Meeting"];

export const ALL_PURPLE_EVENTS = ["Exposure", "Lawsuits vs NSO"];

export const ALL_RED_EVENTS = ["Assassination", "Assault", "Intimidation"];

export const ALL_GREEN_EVENTS = ["Corporate Event"];

export const ALL_WHITE_LINES = ["N/A", "Unknown"];

// This is coming from targets_ordered.json and must exist as a key.
// Event when this category is not appearing in the visualization,
// it will appear in the filters.
export const FILTER_TARGETS_INTERSECTIONAL_NAME = "Investigators";

// All constants referring to initial timeline visualizations and 3d scenes
export const LAYOUT = {
  TIMELINE: {
    AXIS: {
      LEFT: {
        FONT_SIZE: 18,
        WIDTH: 85,
      },
      VERTICAL: {
        FONT_SIZE: 0.8,
      },
      BOTTOM: {
        FONT_SIZE: 12,
      },
    },
    AXES: {
      HIDE_INACTIVE_GRID_ELEMENTS: true,
    },
    SCALES: {
      // Local time makes selected event region occupy a fixed size surface area
      // Global time fits all data points within a certain region
      SHOW_LOCAL_TIME: false,
    },
    SPHERES: {
      SIZE: 0.14,
    },
    LINES: {
      GLOBAL: {
        // HEIGHT is determined in real-time from the scale's bandwidth
        WIDTH: 0.08,
        DEPTH: 0.06,
      },
      CONTEXTUAL: {
        HEIGHT: CHART_DIMENSIONS.Y.BANDWIDTH,
        WIDTH: 0.1,
        DEPTH: 0.03,
      },
    },
    STORY: {
      SHOW: true,
    },
    TRACKER: {
      SHOW: false,
      WIDTH: 180,
      RENDER_AS_CUBE: false,
      COLOR: 0xffff00,
      MASK_OBJECTS: true,
    },
    FILTERS: {
      // Across which columns do we want to implement
      // text search
      TEXT_FIELDS: [
        accessors.id,
        accessors.date.start,
        accessors.description,
        accessors.target.name,
        accessors.target.association,
      ],
      SHOW_TIME: false,
      TIME: {
        START: new Date("2010-01-01"),
        END: new Date("2021-09-01"),
      },
    },
    EVENTS: {
      CONTEXTUAL: {
        OFFSET: -1,
      },
    },
  },
  BREAKPOINTS: {
    TABLET: 600,
  },
  // ORG_CHART: {
  //   PADDING: {
  //     VERTICAL: 0.05,
  //   },
  // },
};

export const lambdaConstants = {
  // in seconds
  delayFunc: (d) => (d.x / CHART_DIMENSIONS.X.MAX) * 0.4,
  noop: () => {},
  true: () => true,
  zero: () => 0,
};
